export const STANDALONE_IMAGE_MAX_PIXELS = 1048576;
export const STANDALONE_IMAGE_DEFAULT_WIDTH = 896;
export const STANDALONE_IMAGE_DEFAULT_HEIGHT = 1152;
export const STANDALONE_IMAGE_SIZE_STEP = 8;
export const STANDALONE_IMAGE_MIN_SIDE = 8;

export const STANDALONE_IMAGE_SIZE_PRESETS = [
  { id: 'portrait', width: 896, height: 1152 },
  { id: 'square', width: 1024, height: 1024 },
  { id: 'landscape', width: 1152, height: 896 },
];

export const snapStandaloneImageSide = (n) => {
  const raw = Number(n);
  if (!Number.isFinite(raw) || raw < STANDALONE_IMAGE_MIN_SIDE) return STANDALONE_IMAGE_MIN_SIDE;
  return Math.max(
    STANDALONE_IMAGE_MIN_SIDE,
    Math.floor(raw / STANDALONE_IMAGE_SIZE_STEP) * STANDALONE_IMAGE_SIZE_STEP,
  );
};

export const clampStandaloneImageSize = (width, height) => {
  const widthMissing = width == null || width === '';
  const heightMissing = height == null || height === '';
  const w = snapStandaloneImageSide(widthMissing ? STANDALONE_IMAGE_DEFAULT_WIDTH : width);
  const h = snapStandaloneImageSide(heightMissing ? STANDALONE_IMAGE_DEFAULT_HEIGHT : height);
  return {
    width: w,
    height: h,
    ok: w * h <= STANDALONE_IMAGE_MAX_PIXELS,
  };
};

export const matchStandaloneImagePreset = (width, height) => (
  STANDALONE_IMAGE_SIZE_PRESETS.find((preset) => preset.width === width && preset.height === height) || null
);

const gcdInt = (a, b) => {
  let x = Math.abs(Math.trunc(a));
  let y = Math.abs(Math.trunc(b));
  while (y) {
    const next = x % y;
    x = y;
    y = next;
  }
  return x || 1;
};

export const formatStandaloneImageRatio = (width, height) => {
  const size = clampStandaloneImageSize(width, height);
  const divisor = gcdInt(size.width, size.height);
  return `${size.width / divisor}:${size.height / divisor}`;
};

export const applyLockedStandaloneImageSize = ({ changed, value, ratio }) => {
  const snapped = snapStandaloneImageSide(value);
  const safeRatio = Number(ratio);
  if (!Number.isFinite(safeRatio) || safeRatio <= 0) {
    return clampStandaloneImageSize(snapped, snapped);
  }
  if (changed === 'width') {
    return clampStandaloneImageSize(snapped, snapped / safeRatio);
  }
  return clampStandaloneImageSize(snapped * safeRatio, snapped);
};

export const scaleStandaloneImageCreditCost = (fullCost, width, height) => {
  const base = Math.max(1, Number(fullCost) || 0);
  const size = clampStandaloneImageSize(width, height);
  if (!size.ok) return base;
  const pixels = size.width * size.height;
  return Math.max(1, Math.ceil((base * (2 * pixels + STANDALONE_IMAGE_MAX_PIXELS)) / (3 * STANDALONE_IMAGE_MAX_PIXELS)));
};
